export default __webpack_public_path__ + "static/media/add.d1b37fca.svg";